import { LOCAL_STORAGE_TOKEN_NAME } from "./consts"

export const getToken = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_NAME) || ""
}

